<template>
    <b-button @click="onClick" variant="link" :class="{ prependWithN: 'text-nowrap' }">
        <span v-if="prependWithN">№</span>
        <span>{{ title }}</span>
    </b-button>
</template>

<script>
    export default {
        name: "ModalButtonCell",
        props: {
            idColumn: { type: Number },
            objectId: { type: Number },
            modalName: { type: String },
            title: {},
            prependWithN: { type: Boolean }
        },
        methods: {
            onClick() {
                this.$emit('object-modal-triggered', this.modalName, this.objectId)
            }
        }
    }
</script>

<style scoped>

</style>